export default {"src":"/_next/static/media/chocolatechips.d7db200b.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};